<template>
  <el-dialog
    :model-value="visible"
    align-center
    :before-close="() => {
      emit('close');
    }"
    width="500px"
  >
    <template #header>
      <div class="my-header">
        <h4 class="px-2 pb-3 text-xl text-[var(--color-text-primary)] font-semibold">
          用户协议和隐私政策
        </h4>
      </div>
    </template>

    <div class="p-[16px] text-sm text-[var(--color-text-primary)]">
      <slot />
    </div>

    <template #footer>
      <div class="flex justify-end">
        <el-button @click="emit('close')">
          取消
        </el-button>
        <el-button type="primary" @click="emit('confirm')">
          同意并继续
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">

const emit = defineEmits(['close', 'confirm', 'openService']);

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
});
</script>
